declare const process: any;

export const environment = {
  production: false,
  apiUrl: "https://fanbase-app-dev.gsa-interactive.net/api",
  host: "https://fanbase-app-dev.gsa-interactive.net",
  backendUrl: "https://fanbase-app-dev.gsa-interactive.net",
  rolesKey: "userDev",
  web3forms: process.env["NG_APP_WEB3_FORMS"],
  firebase: {
    apiKey: process.env["NG_APP_API_KEY_FIREBASE"],
    authDomain: process.env["NG_APP_FIREBASE_AUTH_DOMAIN"],
    projectId: process.env["NG_APP_FIREBASE_PROJECT_ID"],
    storageBucket: process.env["NG_APP_FIREBASE_STORAGE_BUCKET"],
    messagingSenderId: process.env["NG_APP_FIREBASE_MESSAGING_SENDER_ID"],
    appId: process.env["NG_APP_FIREBASE_APP_ID"],
  },
  credits: {
    // Development mode: speeds up credit accumulation for testing
    // "daily" becomes "minutely", "monthly" becomes "hourly"
    devMode: true,
    static: true,
  },
  billing: {
    // Yearly billing strategy:
    // "bonusCredits" - adds bonus percentage to credits (e.g., 15% more credits)
    // "bonusOffTotal" - applies discount to price (e.g., 15% off yearly price, same credits)
    yearlyStrategy: "bonusOffTotal" as "bonusCredits" | "bonusOffTotal",
  },
  apis: {
    url: "/api",
    external: {
      audioAnalyzer: {
        url: "/upload-trial",
      },
    },
    internal: {
      navigation: {
        url: "/navigation",
      },
    },
  },
  api: {
    data: {
      explanations: "/assets/data/enhanced-demo-app-explanations.json",
      navigation: "/assets/data/navigation.json",
      navigationGuest: "/assets/data/navigation-guest.json",
      analyzerDemo: "/assets/data/demo-app-demo.json",
    },
    url: {
      audioAnalyzer: "/api/upload-trial",
    },
    host: {
      frontend: "https://fanbase-app-dev.gsa-interactive.net",
      backend: "https://fanbase-app-dev.gsa-interactive.net",
    },
  },
};
